// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2YgYn","item":"PaymentsMobile_item__2qB6m","label":"PaymentsMobile_label__2shRr","amount":"PaymentsMobile_amount__2r6YY"};